'use client'

import RightOutlined from '@ant-design/icons/RightOutlined'
import LeftOutlined from '@ant-design/icons/LeftOutlined'
import { ReactNode, forwardRef } from 'react'
import Carousel, { ReactElasticCarouselProps } from 'react-elastic-carousel'
import { down } from 'styled-breakpoints'
import styled, { css } from 'styled-components'
import breakpoints from '@/utils/breakpoints'

// eslint-disable-next-line react/display-name
const CustomCarousel = forwardRef<
  any,
  ReactElasticCarouselProps & { children: ReactNode[] }
>((props, ref) => <Carousel ref={ref} {...props} />)

export const CarouselContainer = styled.div`
  width: 100%;
`

const SliderContainerCatch = `${breakpoints(
  'overflow',
  '',
  [
    {
      700: `visible;`,
    },
  ],
  'max-width'
)}`

const CarouselWrapperWidthCatch = `${breakpoints(
  'width',
  '',
  [
    {
      480: `109.2%;`,
    },
  ],
  'max-width'
)}`

export const CarouselWrapper = styled(CustomCarousel)<
  ReactElasticCarouselProps & { isRequiredDisplayDotted?: boolean }
>`
  ${({ isRequiredDisplayDotted }) => css`
    .rec.rec-carousel {
      width: 101%;
      ${CarouselWrapperWidthCatch}
    }
    .rec.rec-arrow {
      box-shadow: none;
      background-color: unset;
      display: none;
    }

    .rec.rec-arrow:hover {
      color: ${'#000000'};
    }

    .rec-carousel-item:focus {
      color: ${'#000000'};
    }

    .rec.rec-arrow {
      color: ${'#000000'};
    }

    .rec.rec-dot {
      background-color: ${'#000000'};
      box-shadow: none;
    }

    .rec.rec-dot:focus {
      background-color: unset;
      box-shadow: 0 0 1px 3px ${'#000000'};
    }
    .rec.rec-dot:hover {
      background-color: unset;
      box-shadow: 0 0 1px 3px ${'#000000'};
    }

    .rec.rec-dot.rec-dot_active {
      background-color: unset;
      box-shadow: 0 0 1px 3px ${'#000000'};
    }

    .rec.rec-slider-container {
      ${isRequiredDisplayDotted ? '' : SliderContainerCatch}
    }
  `}
`

const LeftOutlinedWrapperCacth = `${breakpoints(
  'visibility',
  '',
  [
    {
      400: `hidden;`,
    },
  ],
  'max-width'
)}`

export const LeftOutlinedWrapper = styled(LeftOutlined)<{ $disabled: boolean }>`
  ${({ $disabled }) => css`
    font-size: 12px;
    width: 10%;
    display: flex;
    justify-content: center;
    ${$disabled ? `pointer-events: none;` : ''}

    ${LeftOutlinedWrapperCacth}
  `}
`

const RightOutlinedWrapperCatch = `${breakpoints(
  'visibility',
  '',
  [
    {
      400: `hidden;`,
    },
  ],
  'max-width'
)}`

export const RightOutlinedWrapper = styled(RightOutlined)<{
  $disabled: boolean
}>`
  ${({ $disabled }) => css`
    font-size: 12px;
    width: 10%;
    ${$disabled ? `pointer-events: none;` : ''}
    display: flex;
    justify-content: center;

    ${RightOutlinedWrapperCatch}
  `}
`

export const FlexPaginate = styled.div<{ $show?: boolean }>`
  ${({ $show }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    width: 100%;
    flex-wrap: wrap;
    ${down('sm')} {
      display: ${$show ? 'flex' : 'none'};
    }
  `}
`

export const DotContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  max-width: 80%;
`

export const Dot = styled.div<{ $isActive: boolean }>`
  ${({
    $isActive,
    theme: {
      base: {
        shade: { white },
      },
    },
  }) => css`
    height: 8px;
    width: 8px;
    background-color: ${$isActive ? `${white[0]}` : `${'#000000'}`};
    border-radius: 50%;
    cursor: pointer;
    display: inline-block !important;

    ${$isActive ? ' border: 1.5px solid black;' : ''}
  `}
`

